import React, { useRef, useLayoutEffect, useState } from "react";
import gsap from "gsap";
import { personalDetails } from "../Details";
import { Link } from "react-router-dom";

function Home() {
  const { name, tagline, img } = personalDetails;
  const h11 = useRef();
  const h12 = useRef();
  const h13 = useRef();
  const containerRef = useRef();
  const myimageref = useRef();
  const buttonRef = useRef();
  const waveRef = useRef(); // Ref for waving emoji

  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    padding: "15px 30px",
    fontSize: "20px",
    fontWeight: "bold",
    color: "#fff",
    background: "linear-gradient(45deg, #ff416c, #ff4b2b)", // Brighter gradient
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    transform: isHovered ? "scale(1.08)" : "scale(1)",
    boxShadow: isHovered
      ? "0 0 20px rgba(255, 75, 43, 0.6)" // Glowing border effect
      : "none",
  };

  const animationPlayed = useRef(false);

  useLayoutEffect(() => {
    if (!animationPlayed.current) {
      const tl = gsap.timeline();

      tl.set(containerRef.current, { visibility: "visible" })
        .from(
          [h11.current, h12.current, h13.current],
          {
            x: "-100%",
            opacity: 0,
            duration: 2,
            ease: "Power3.easeOut",
            stagger: 0.2,
          },
          "<"
        )
        .from(
          myimageref.current,
          {
            x: "200%",
            opacity: 0,
            duration: 2,
            ease: "Power3.easeOut",
          },
          "<"
        )
        .from(
          buttonRef.current,
          {
            y: 900,
            opacity: 0,
            duration: 1,
            ease: "Power3.easeOut",
          },
          "<"
        );

      // Waving animations
      gsap.to(waveRef.current, {
        rotation: 20,
        yoyo: true,
        repeat: 7,
        transformOrigin: "70% 70%",
        duration: 0.5,
        ease: "Power3.easeInOut",
      });

      animationPlayed.current = true;
    }
  }, []);

  return (
    <main
      ref={containerRef}
      style={{ visibility: "hidden" }}
      className="container mx-auto max-width section md:flex justify-between items-center"
    >
      <div>
        <h1
          ref={h11}
          className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          Hi,{" "}
          <span ref={waveRef} style={{ display: "inline-block" }}>
            👋
          </span>
          <br />
          My Name is
          <br />
        </h1>
        <Link
          to="/about"
          className="hover:scale-105 transition-transform inline-block"
        >
          <h1
            ref={h12}
            className="text-2xl bg-clip-text bg-gradient text-transparent md:text-4xl xl:text-5xl xl:leading-tight font-bold"
          >
            {name}
          </h1>
        </Link>
        <h2
          ref={h13}
          className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          {tagline}
        </h2>
        <div className="mt-5">
          <Link to="/projects">
            <button
              ref={buttonRef}
              style={buttonStyle}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              Explore My Work
            </button>
          </Link>
        </div>
      </div>
      <div className="mt-5 md:mt-0">
        <Link
          to="/about"
          className="hover:scale-105 transition-transform block"
        >
          <img
            ref={myimageref}
            className="w-1/2 md:ml-auto"
            src={img}
            alt={name}
          />
        </Link>
      </div>
    </main>
  );
}

export default Home;
